module.exports = __webpack_public_path__ + "static/img/zd06.8def31aa.svg";